import dayjs from 'dayjs';
import {AvailablePatient, MappedPatients, PatientOptionLabel} from '../types';
import {dateFormat} from '../../../constants/constants';

const SURVEY_LIST_DATE_FORMAT = 'MM-DD-YYYY h:mm A';

export const getPatientLabel = ({
  firstName,
  lastName,
  id
}: PatientOptionLabel): string =>
  `${firstName} ${lastName} (${id})`;

export const getCallSheetOptionLabel = (id, appointment): string => {
  const {appointmentDate, treatment} = appointment || {};
  const {displayName} = treatment || {};

  const date = appointmentDate ?
    dayjs(appointmentDate).format(dateFormat) :
    null;

  if (!id || !date || !displayName) {
    return id || date || displayName;
  }

  return `${id}/${date}/${displayName}`;
};

export const mapAvailablePatients = (
    data: AvailablePatient[] = []
): MappedPatients => {
  const patientsCallSheets = {};

  if (!data?.length) {
    return {patientsCallSheets, patientOptions: []};
  }

  const patientOptions = data.map(({
    id, firstName, lastName, callSheets
  }) => {
    const label = getPatientLabel({firstName, lastName, id});
    const fullName = `${firstName} ${lastName}`;

    patientsCallSheets[id] = callSheets.map(({id, appointment}) => ({
      value: `${id}`,
      label: getCallSheetOptionLabel(id, appointment)
    }));

    return {
      value: `${id}`,
      label,
      fullName
    };
  });

  return {patientsCallSheets, patientOptions};
};

export const getSurveyListDate = (date: string) =>
  dayjs(date).format(SURVEY_LIST_DATE_FORMAT);
